export default "__VITE_ASSET__BZK2T26A__"